import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useAuth } from '../contexts/auth-context';
import { Link, useNavigate } from 'react-router-dom';
import { ADMIN_PATH, LANDING_PATH, LOGIN_PATH, PROFILE_PATH } from '../App';
import SocialMediaLink from '../components/social-media-link';
import LanguageSwitcher from '../components/language-switcher';
import { useTranslation } from 'react-i18next';
import { FileText, Mail, Phone } from 'lucide-react';
import { PRIVACY_POLICY_PATH, TERMS_OF_SERVICE_PATH, RETURN_AND_REFUND_POLICY_PATH } from '../App';

const About = () => {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (

        <div className='flex flex-col items-center w-full gap-12 pt-24 max-[980px]:pt-12 pb-24'>
            <div className="flex flex-center gap-12 max-w-[1000px] pt-6 flex-1">
                <img className='w-full h-full object-contain opacity-100 max-w-xl rounded-sm border-2' src={"/assets/img/about-bg.jpeg"} alt="logo" />
                <h1 className='text-4xl font-bold'>{t('about.ourStory')}</h1>
                <p>{t('about.story')}</p>
                <p><strong>{t('about.mission')}</strong> {t('about.missionText')}</p>
                <p><strong>{t('about.history')}</strong> {t('about.historyText')}</p>
                <p><strong>{t('about.community')}</strong> {t('about.communityText')}</p>
                <h1 className='text-4xl font-bold'>{t('about.contactUs')}</h1>
                <div className="flex w-full flex-col md:flex-row items-center justify-center gap-4">
                    <p className='inline-flex items-center gap-2 btn btn-link text-current'>
                        <Mail /> <a href="mailto:malaysiafightleague@gmail.com">malaysiafightleague@gmail.com</a>
                    </p>
                    <p className='inline-flex items-center gap-2 btn btn-link text-current'>
                        <Phone /> <a href="tel:+60109831808">(+60) 10-983 1808</a>
                    </p>
                </div>
                <h1 className='text-4xl font-bold'>Legal Documents</h1>
                <div className="flex w-full flex-col md:flex-row items-center justify-center gap-4">
                    <Link className='inline-flex items-center gap-2 btn btn-link text-current' to={PRIVACY_POLICY_PATH}>
                        <FileText />
                        <span>Privacy Policy</span>
                    </Link>
                    <Link className='inline-flex items-center gap-2 btn btn-link text-current' to={TERMS_OF_SERVICE_PATH}>
                        <FileText />
                        <span>Terms of Service</span>
                    </Link>
                    <Link className='inline-flex items-center gap-2 btn btn-link text-current' to={RETURN_AND_REFUND_POLICY_PATH}>
                        <FileText />
                        <span>Return and Refund Policy</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default About;

